import { useEffect, useState } from 'react'

export function useLocalStorage(key, fallback?: any, conversionFunc?: any) {
  const val = localStorage.getItem(key) || fallback
  const [storageItem, setStorageItem] = useState(conversionFunc ? conversionFunc(val) : val)

  useEffect(() => {
    localStorage.setItem(key, storageItem)
  }, [key, storageItem])

  return [storageItem, setStorageItem]
}
